export enum LegalType {
  KassenSichV,
  DSFinVK,
  Receipt,
  Submission = 4
}

export class LegalTypeHelper {
  private static names: string[] = ["KassenSichV (TSE)", "DSFinV-K", "Beleg", "", "Kassenmeldung"];

  public static GetName(value: LegalType): string {
    return this.names[value];
  }
}
